import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';

import * as actions from '../../store/actions/index';
import Text from '../../components/Text/Text';

const Post = (props) => {
  const { noHome, getPage } = props;
  const [postPath, setPostPath] = useState('');
  let imageList = [];

  useEffect(() => {
    window.scrollTo(0, 0);
    noHome();
    const post_path = props.item.path ? props.item.path : props.item.relative.substring(1);
    setPostPath(post_path);

    const node_id = props.item.uri.split('/')[1];
    getPage(node_id);
  }, [noHome, getPage, props.item.uri]);

  if (props.image) {
    imageList = props.image.split(',');
  }
  const truncate = props.text && props.text.length > 150 ? props.text.substring(0, 150) + "..." : props.text;

  return (
    <>
      <h1 className="pl-5 mb-4 sm:mb-10 font-serif text-xl sm:text-4xl sm:leading-10">{props.title}</h1>
      <Text>
        {imageList.length >= 1 ? imageList.map(image => {
          return <img className="mx-auto border-1 mb-2 border border-grey-dark p-2" src={props.domain + image.trim()} alt={props.title} />
        }) : null}
        <div className='mt-5 pr-5 text-base font-verdana text-grey-darker' dangerouslySetInnerHTML={{ __html: props.text }} />
      </Text>
    </>
  )
}

const mapsStateToProps = state => {
  return {
    domain: state.domain,
    title: state.node.title,
    text: state.node.text,
    image: state.node.image,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    noHome: () => dispatch(actions.noHome()),
    getPage: (id) => dispatch(actions.getPage(id))
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(Post);
